import { Component, inject, viewChild, ChangeDetectionStrategy } from '@angular/core';
import { AuthStore } from '@features/authentication/state/auth.store';
import { PurchaseFlowService } from '@features/purchase-flow/application/purchase-flow/purchase-flow.service';
import { NavigationService } from '@core/services/navigation/navigation.service';
import { ResetConfirmationModalComponent } from './reset-confirmation-modal/reset-confirmation-modal.component';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'd2d-guest-banner',
  imports: [ResetConfirmationModalComponent, TranslocoDirective],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './guest-banner.component.html',
})
export class GuestBannerComponent {
  private readonly authStore = inject(AuthStore);
  private readonly purchaseFlowService = inject(PurchaseFlowService);
  private readonly navigationService = inject(NavigationService);

  private readonly resetModal = viewChild.required(ResetConfirmationModalComponent);

  isGuestFlow = this.authStore.isGuestFlow;
  guestEmail = this.authStore.guestEmail;

  openResetModal(): void {
    this.resetModal().open();
  }

  reset(): void {
    this.authStore.clearGuestToken();
    this.purchaseFlowService.resetForm();
    this.navigationService.navigate('');
  }
}
